// Is the TaskPogoPlaceWrite mutation deployed on this branch?
//
// The same shape as tripWeatherEmail.mjs's gate, for the same reason: the
// mutation is reached only through AppSync, so no Function URL appears when
// its backend lands, and amplify/backend.ts publishes this flag to be that
// key. AppSync rejects a WHOLE request naming a field the branch's schema does
// not have, so Database.mjs's place writers must not name the mutation until
// the schema is live -- while the key is absent they fall back to the model's
// generated create/update/delete, which is what every branch had before.
//
// Once every branch is deployed the fallback is dead code and the model grants
// come off (amplify/data/resource.ts, the TaskPogoPlace comment); the gate can
// go with them.

import outputs from '../amplify_outputs.json';

export function placeWriteAvailable() {
  return Boolean(outputs?.custom?.placeWriteEnabled);
}
